import { ReactNode } from 'react';

export enum BadgeVariant {
	Neutral = 'neutral',
	Warning = 'warning',
	Fail = 'fail',
	Success = 'success',
	Brand = 'brand',
}

export interface BadgeProps {
	className?: string;
	children: string;
	variant?: BadgeVariant;
}
